import React, { useState, useRef, useEffect } from 'react'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import { Button, Nav } from 'react-bootstrap'

import { useLazyQuery, useSubscription } from '@apollo/client'

import navStyles from '@shared/components/commonNav/style.module.scss'
import styles from './style.module.scss'
import { RECENT_OVER } from '@graphql/match/match.query'
import { GET_RECENT_OVER } from '@graphql/match/match.subscription'
import { isBottomReached } from '@shared-submodule/utils'
import { oversLoader } from '@shared/libs/allLoader'

const OverList = dynamic(() => import('../overList'))
const NoData = dynamic(() => import('@shared/components/noData'))
// const Ads = dynamic(() => import('@shared/components/ads'), { ssr: false })

const MatchDetailOvers = ({ data, matchDetail, is100 }) => {
  const [selectedTab, setSelectedTab] = useState(data?.aResults?.[0]?.nInningNumber || matchDetail?.nLatestInningNumber)
  const [enablebtn, setEnableBtn] = useState(data?.aResults?.length >= 5)
  const isNext = useRef(data?.aResults?.length >= 5)
  const loading = useRef(false)
  const btnDisabled = useRef(false)
  const [overData, setOverData] = useState(data?.aResults)
  const payloads = useRef({
    iMatchId: matchDetail?._id,
    nLimit: 5,
    nInningNumber: matchDetail?.nLatestInningNumber,
    sOver: null,
    isFront: true
  })
  let selectedTabDataCount = 0

  const [getMoreOvers, { loading: overLoading }] = useLazyQuery(RECENT_OVER, { fetchPolicy: 'network-only' })
  typeof window !== 'undefined' && useSubscription(GET_RECENT_OVER, {
    variables: { input: { iMatchId: matchDetail?._id, nInningNumber: matchDetail?.nLatestInningNumber } },
    onData: ({ data }) => {
      const over = data?.data?.listMatchOvers
      if (over && over?.nInningNumber === payloads.current.nInningNumber) {
        if (overData[0]?.sOver === over?.sOver) {
          setOverData(overData?.map((item) => {
            if (item?.sOver === over?.sOver) {
              return { ...item, aBall: over?.aBall }
            }
            return item
          }))
        } else {
          setOverData([over, ...overData])
        }
      }
    }
  })

  const handleLoadMore = () => {
    payloads.current = { ...payloads.current, nInningNumber: selectedTab }
    getMoreOvers({ variables: { input: { ...payloads.current } } }).then((updatedOverData) => {
      updatedOverData.data && setOverData([...overData, ...updatedOverData.data?.listMatchOvers?.aResults])
    })
    setEnableBtn(false)
    btnDisabled.current = true
  }

  const handleInning = (inning) => {
    if (selectedTab !== inning?.nInningNumber) {
      setSelectedTab(inning.nInningNumber)
      payloads.current = { ...payloads.current, nInningNumber: inning.nInningNumber, sOver: null }
      getMoreOvers({ variables: { input: { ...payloads.current } } }).then((updatedOverData) => {
        if (updatedOverData?.data) {
          setOverData(updatedOverData?.data?.listMatchOvers?.aResults)
          isNext.current = updatedOverData.data?.listMatchOvers?.aResults?.length >= 5
        }
      })
      setEnableBtn(true)
      btnDisabled.current = false
      selectedTabDataCount = 0
    }
  }

  useEffect(() => {
    // get last over from overData
    const lastItem = overData[Object.keys(overData)[Object.keys(overData).length - 1]]
    payloads.current.sOver = lastItem?.sOver
    if (btnDisabled.current) {
      loading.current = false
      const tempId = overData[overData.length - 1]?.sOver + overData[overData.length - 1]?.nInningNumber
      isBottomReached(tempId, isReached)
    }
  }, [overData])

  async function isReached(reach) {
    if (reach && !loading.current && isNext.current) {
      loading.current = true
      setPayload()
      getMoreOvers({ variables: { input: { ...payloads.current } } }).then((updatedOverData) => {
        if (updatedOverData.data) {
          setOverData([...overData, ...updatedOverData.data?.listMatchOvers?.aResults])
          isNext.current = updatedOverData.data?.listMatchOvers?.aResults?.length >= 5
        }
      })
    }
  }

  function setPayload() {
    payloads.current = { ...payloads.current }
  }

  return (
    <>
      <Nav className={`${navStyles.commonNav} ${navStyles.pillsNav} flex-nowrap text-nowrap scroll-list justify-content-sm-left ${matchDetail?.aInning?.length < 2 && 'justify-content-left'} ${matchDetail?.aInning?.length > 2 && styles.testMatch} `}>
        {matchDetail?.aInning?.map((inning, index) => {
          return (
            <Nav.Item
              key={index}
              className={navStyles.item}
              onClick={() => handleInning(inning)}
            >
              <a
                className={`${selectedTab === inning?.nInningNumber && navStyles.active} nav-link`}
              >
                {/* {inning?.sShortName} */}
                {index === 0 ? <>
                  {inning?.sShortName}
                </> : <>
                  {inning?.sShortName}
                </>
                }
              </a>
            </Nav.Item>
          )
        })}
      </Nav>
      {
        !overLoading && overData?.length === 0 && <NoData />
      }
      {
        !overLoading && overData?.map((over, index) => {
          if (selectedTab === over?.nInningNumber) {
            ++selectedTabDataCount
            return (
              <React.Fragment key={index}>
                {/* {index === 5 && (
                  <Ads
                    id="div-ad-gpt-138639789-1660147282-2"
                    adIdDesktop="oneturf2022_Desktop_LiveScore_MID_728x90"
                    adIdMobile="oneturf2022_Mobile_LiveScore_MID_300x250"
                    dimensionDesktop={[728, 90]}
                    dimensionMobile={[300, 250]}
                    mobile
                    className={'text-center mb-3'}
                  />
                )} */}
                {/* {index === 10 && (
                  <Ads
                    id="div-ad-gpt-138639789-1660147282-3"
                    adIdDesktop="oneturf2022_Desktop_LiveScore_MID2_728x90"
                    adIdMobile="oneturf2022_Mobile_LiveScore_MID2_300x250"
                    dimensionDesktop={[728, 90]}
                    dimensionMobile={[300, 250]}
                    mobile
                    className={'text-center mb-3'}
                  />
                )} */}
                <OverList is100={is100} data={over} id={over?.sOver + over?.nInningNumber} />
              </React.Fragment>
            )
          } else {
            return <></>
          }
        })
      }
      {overLoading && oversLoader()}
      {
        enablebtn && selectedTabDataCount >= 5 && <div className="text-center my-2">
          <Button className="theme-btn" onClick={() => handleLoadMore()}>{'Load more'}</Button>
        </div>
      }
    </>
  )
}

MatchDetailOvers.propTypes = {
  data: PropTypes.object,
  matchDetail: PropTypes.object,
  is100: PropTypes.bool
}

export default MatchDetailOvers
